import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import Puff from 'react-loading-icons/dist/esm/components/puff';
import axios from 'axios';
import { useStateContext } from '../Context/ContextProvider';
import { FaFilter, FaFileInvoice, FaPrint, FaCalendarAlt, FaUserTie, FaMapMarkerAlt } from 'react-icons/fa';

function BatchListInvoices() {
  const [isClick, setIsClick] = useState(false);
  const [isClickPrint, setIsClickPrint] = useState(false);
  const [defaultsalesman, setDefaultSalesman] = useState('');
  const [defaultsector, setDefaultSector] = useState('');
  const [salesman, setSalesman] = useState([]);
  const [sector, setSector] = useState([]);
  const [manualdate, setManualDate] = useState('');
  const [manualdateto, setManualDateTo] = useState('');
  const { type, userId } = useStateContext();
  const [invoiceList, setInvioceList] = useState([]);
  const [invoiceNumbersRange, setInvoiceNumbersRange] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);

  useEffect(() => {
    if (invoiceList.length > 0) {
      if (invoiceNumbersRange.length === invoiceList.length) {
        setIsAllChecked(true);
      } else {
        setIsAllChecked(false);
      }
    }
  }, [invoiceNumbersRange, invoiceList]);

  const handleCheckAllChange = (e) => {
    if (e.target.checked) {
      setInvoiceNumbersRange(invoiceList.map((invoice) => invoice.visitor_id));
    } else {
      setInvoiceNumbersRange([]);
    }
  };

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setInvoiceNumbersRange((prev) => [...prev, id]);
    } else {
      setInvoiceNumbersRange((prev) => prev.filter((item) => item !== id));
    }
  };

  useEffect(() => {
    axios.get('/api/getsectors').then(res => {
      setSector(res.data.sectors);
      setDefaultSector(res.data.sectors[0]['id']);
    });
  }, []);

  useEffect(() => {
    axios.get('/api/getsalesman').then(res => {
      setSalesman(res.data.salesman);
      setDefaultSalesman(res.data.salesman[0]['id']);
    });
  }, []);

  const handleFetchList = () => {
    setIsClick(true);
    if (manualdate === '' || manualdateto === '') {
      alert('Date Must Be Selected');
      setIsClick(false);
      return false;
    }
    const data = {
      'salesman': type === 'Admin' ? defaultsalesman : userId,
      'sector': defaultsector,
      'date': manualdate,
      'dateto': manualdateto
    };

    axios({
      url: 'api/get/batch/invoices',
      method: 'POST',
      data: data
    }).then((response) => {
      setInvioceList(response.data);
      setIsClick(false);
    });
  };

  const handleFetchReport = () => {
    setIsClickPrint(true);
    if (invoiceNumbersRange.length < 1) {
      alert('Select Invoices First');
      setIsClickPrint(false);
      return false;
    }
    const data = {
      'salesman': type === 'Admin' ? defaultsalesman : userId,
      'sector': defaultsector,
      'date': manualdate,
      'dateto': manualdateto,
      'visitorids': invoiceNumbersRange,
    };

    axios({
      url: 'api/post/batch/invoices',
      method: 'POST',
      responseType: 'blob',
      data: data
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      setIsClickPrint(false);
    });
  };

  return (
    <div className="batch-invoices-container">
      <div className="batch-invoices-header">
        <h1 className="page-title">Batch Invoices</h1>
        <div className="header-underline"></div>
        <p className="page-subtitle">Generate and print multiple invoices at once</p>
      </div>

      <div className="batch-invoices-content">
        {/* Left Panel - Filters */}
        <div className="filters-panel">
          <div className="panel-header">
            <FaFilter className="panel-icon" />
            <h3>Filter Criteria</h3>
          </div>

          <div className="filter-form">
            <div className="form-group">
              <label>
                <FaCalendarAlt className="input-icon" />
                From Date
              </label>
              <input
                type="date"
                className="modern-input"
                value={manualdate}
                onChange={(e) => setManualDate(e.target.value)}
                placeholder="Select start date"
              />
            </div>

            <div className="form-group">
              <label>
                <FaCalendarAlt className="input-icon" />
                To Date
              </label>
              <input
                type="date"
                className="modern-input"
                value={manualdateto}
                onChange={(e) => setManualDateTo(e.target.value)}
                placeholder="Select end date"
              />
            </div>

            <div className="form-group">
              <label>
                <FaMapMarkerAlt className="input-icon" />
                Region
              </label>
              <select
                className="modern-select"
                value={defaultsector}
                onChange={(e) => setDefaultSector(e.target.value)}
              >
                {sector && sector.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                <FaUserTie className="input-icon" />
                Sales Associate
              </label>
              <select
                className="modern-select"
                value={defaultsalesman}
                onChange={(e) => setDefaultSalesman(e.target.value)}
              >
                {salesman && salesman.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <button
              className="fetch-btn"
              onClick={handleFetchList}
              disabled={type!=='Managment'?true:false}
            >
              {isClick ? (
                <>
                  <Puff width={20} height={20} stroke="#fff" />
                  <span>Fetching...</span>
                </>
              ) : (
                <>
                  <FaFileInvoice />
                  <span>Fetch Invoices</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Right Panel - Invoice List */}
        <div className="invoices-panel">
          <div className="panel-header">
            <FaFileInvoice className="panel-icon" />
            <h3>Invoice List</h3>
            {invoiceList.length > 0 && (
              <span className="invoice-count">{invoiceList.length} invoices</span>
            )}
          </div>

          {invoiceList.length === 0 ? (
            <div className="empty-state">
              <FaFileInvoice className="empty-icon" />
              <p>No invoices to display</p>
              <span>Select filters and click "Fetch Invoices"</span>
            </div>
          ) : (
            <>
              <div className="table-wrapper">
                <Table className="modern-table" hover responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Customer Name</th>
                      <th>Salesman</th>
                      <th>Region</th>
                      <th>City</th>
                      <th>Invoice No</th>
                      <th className="checkbox-cell">
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={handleCheckAllChange}
                          />
                          <span>All</span>
                        </label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceList.map((item, index) => (
                      <tr key={index} className="invoice-row">
                        <td className="serial">{item.Sr}</td>
                        <td className="customer-name">{item.customerName}</td>
                        <td>{item.salesmanName}</td>
                        <td>{item.sectorName}</td>
                        <td>{item.subsectorName}</td>
                        <td className="invoice-number">{item.visitor_id}</td>
                        <td className="checkbox-cell">
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={invoiceNumbersRange.includes(item.visitor_id)}
                              value={item.visitor_id}
                              onChange={(e) => handleCheckboxChange(e, item.visitor_id)}
                            />
                          </label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="print-section">
                <button
                  className="print-btn"
                  onClick={handleFetchReport}
                  disabled={isClickPrint || invoiceNumbersRange.length === 0}
                >
                  {isClickPrint ? (
                    <>
                      <Puff width={20} height={20} stroke="#fff" />
                      <span>Generating PDF...</span>
                    </>
                  ) : (
                    <>
                      <FaPrint />
                      <span>Print Selected ({invoiceNumbersRange.length})</span>
                    </>
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      <style>{`
        .batch-invoices-container {
          min-height: 100vh;
          background: linear-gradient(145deg, #f8f9fc 0%, #eef2f7 100%);
          padding: 25px 30px;
        }

        .batch-invoices-header {
          margin-bottom: 30px;
        }

        .page-title {
          font-size: 28px;
          font-weight: 700;
          color: #1e3c72;
          margin: 0 0 10px 0;
        }

        .header-underline {
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 2px;
          margin-bottom: 12px;
        }

        .page-subtitle {
          font-size: 14px;
          color: #666;
          margin: 0;
        }

        .batch-invoices-content {
          display: grid;
          grid-template-columns: 380px 1fr;
          gap: 25px;
        }

        /* Filters Panel */
        .filters-panel {
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          height: fit-content;
          position: sticky;
          top: 20px;
        }

        .invoices-panel {
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          overflow: hidden;
        }

        .panel-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 18px 22px;
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          color: white;
        }

        .panel-icon {
          font-size: 20px;
        }

        .panel-header h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          flex: 1;
        }

        .invoice-count {
          background: rgba(255, 255, 255, 0.2);
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }

        .filter-form {
          padding: 22px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #555;
          margin-bottom: 8px;
        }

        .input-icon {
          font-size: 14px;
          color: #667eea;
        }

        .modern-input, .modern-select {
          width: 100%;
          padding: 12px 14px;
          border: 1.5px solid #e0e0e0;
          border-radius: 10px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: #fafafa;
        }

        .modern-input:focus, .modern-select:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .fetch-btn {
          width: 100%;
          padding: 12px 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
          margin-top: 10px;
        }

        .fetch-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
        }

        .fetch-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* Empty State */
        .empty-state {
          text-align: center;
          padding: 60px 20px;
          color: #999;
        }

        .empty-icon {
          font-size: 60px;
          color: #ccc;
          margin-bottom: 15px;
        }

        .empty-state p {
          font-size: 16px;
          margin: 0 0 5px 0;
          color: #666;
        }

        .empty-state span {
          font-size: 13px;
        }

        /* Table Styles */
        .table-wrapper {
          padding: 0;
          overflow-x: auto;
          max-height: 500px;
          overflow-y: auto;
        }

        .modern-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 800px;
        }

        .modern-table th {
          background: #f8f9fc;
          color: #1e3c72;
          padding: 14px 12px;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #e0e0e0;
          position: sticky;
          top: 0;
          background: white;
          z-index: 10;
        }

        .modern-table td {
          padding: 12px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 13px;
          color: #555;
        }

        .invoice-row:hover td {
          background: #f8f9fc;
        }

        .serial {
          font-weight: 600;
          color: #667eea;
        }

        .customer-name {
          font-weight: 500;
          color: #333;
        }

        .invoice-number {
          font-family: monospace;
          font-weight: 600;
          color: #1e3c72;
        }

        .checkbox-cell {
          text-align: center;
          width: 60px;
        }

        .checkbox-label {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          font-size: 13px;
        }

        .checkbox-label input {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        /* Print Section */
        .print-section {
          padding: 20px;
          border-top: 1px solid #f0f0f0;
          background: #fafafa;
        }

        .print-btn {
          width: 100%;
          padding: 14px 20px;
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .print-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(40, 167, 69, 0.4);
        }

        .print-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* Scrollbar */
        .table-wrapper::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .table-wrapper::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .table-wrapper::-webkit-scrollbar-thumb {
          background: #667eea;
          border-radius: 10px;
        }

        .table-wrapper::-webkit-scrollbar-thumb:hover {
          background: #764ba2;
        }

        /* Responsive */
        @media (max-width: 992px) {
          .batch-invoices-content {
            grid-template-columns: 1fr;
          }

          .filters-panel {
            position: static;
          }

          .batch-invoices-container {
            padding: 20px;
          }
        }

        @media (max-width: 768px) {
          .batch-invoices-container {
            padding: 15px;
          }

          .page-title {
            font-size: 22px;
          }

          .filter-form {
            padding: 18px;
          }

          .panel-header {
            padding: 14px 18px;
          }
        }
      `}</style>
    </div>
  );
}

export default BatchListInvoices;